// Studio Preview-tab substitution. Replaces:
//   - $varName / $a.b.c — looked up in fixture as a JS path
//   - <token> — looked up in fixture.brackets[token]
//
// Code blocks (fenced ``` ``` or 4-space indented) are passthrough — we
// don't substitute inside them so authoring docs that show literal
// directives stay literal.

export type Fixture = Record<string, unknown>;

function getPath(obj: any, path: string): unknown {
  return path.split('.').reduce((acc, key) => (acc == null ? acc : acc[key]), obj);
}

function isInFencedBlock(input: string, index: number): boolean {
  // Count unbalanced ``` markers before index. Odd count => inside fence.
  const before = input.slice(0, index);
  const matches = before.match(/```/g);
  return (matches?.length ?? 0) % 2 === 1;
}

export function applyFixture(input: string, fixture: Fixture): string {
  // $-substitution first
  const dollarRe = /\$([a-zA-Z][a-zA-Z0-9_]*(?:\.[a-zA-Z][a-zA-Z0-9_]*)*)/g;
  let out = input.replace(dollarRe, (match, path, offset) => {
    if (isInFencedBlock(input, offset)) return match;
    const v = getPath(fixture, path);
    return typeof v === 'string' || typeof v === 'number' ? String(v) : match;
  });

  // <bracket> substitution
  const brackets = (fixture.brackets ?? {}) as Record<string, unknown>;
  const bracketRe = /<([a-zA-Z][a-zA-Z0-9_]*)>/g;
  out = out.replace(bracketRe, (match, key, offset) => {
    if (isInFencedBlock(out, offset)) return match;
    const v = brackets[key];
    return typeof v === 'string' || typeof v === 'number' ? String(v) : match;
  });

  return out;
}
